<script setup lang="ts">
import { useAuthUser } from '@/helpers/globals';
import { useRouter } from 'vue-router';

const router = useRouter();

function onAccountClick() {
    router.push({ name: 'useraccount-settings-profile', params: {} });
}
function onNotificationsClick() {
    router.push({ name: 'useraccount-notifications', params: {} });
}

const { username } = defineProps<{
    username: string;
}>();

const user = useAuthUser();
const getUsername = () => {
  if(user?.active_role_stelle) {
    return username + ' (' + user.active_role_stelle + ')'
  }
    return username;
};

defineEmits(['logout', 'changerole', 'legacyui']);
</script>
<template>
    <!-- Account navigation, which is opened in an overlay -->
    <ktg-account-navigation :user-name="getUsername()" icon-button-label="Account">
        <ktg-account-navigation-item icon="activities" @item-click="onAccountClick">
            {{ $t('settings') }}
        </ktg-account-navigation-item>
        <ktg-account-navigation-item icon="bubble-empty" @item-click="onNotificationsClick">
            {{ $t('notifications') }}
        </ktg-account-navigation-item>
        <ktg-account-navigation-item icon="user" @item-click="$emit('changerole')">
            {{ $t('rolle_wechseln') }}
        </ktg-account-navigation-item>
        <ktg-account-navigation-item icon="arrow-swap" @item-click="$emit('legacyui')">
            {{ $t('to_legacy_ui') }}
        </ktg-account-navigation-item>
        <ktg-account-navigation-item icon="log-out" @item-click="$emit('logout')">
            {{ $t('logout') }}
        </ktg-account-navigation-item>
    </ktg-account-navigation>
</template>
